import { QueryClient } from "@tanstack/react-query";

import { MatchesQueryKeys } from "@/tanstackQuery/queries/matches";

// Every cache the admin match lists read from. They are separate query keys
// (plain, paginated and infinite), so invalidating one leaves the others
// showing pre-edit data until the page is reloaded.
const MATCH_LIST_KEYS = [
  MatchesQueryKeys.FullMatches,
  MatchesQueryKeys.FullMatchesPaginated,
  MatchesQueryKeys.FullMatchesInfinite,
];

/**
 * Drops every match-list cache after a write that can change a listed row —
 * a save, a lock toggle, a status change, an event import.
 *
 * One definition on purpose (rule 3/6): each mutation used to name the keys it
 * happened to know about, which is why a saved score or a released lock only
 * appeared after a manual refresh.
 */
export const invalidateMatchLists = (queryClient: QueryClient): void => {
  for (const queryKey of MATCH_LIST_KEYS) {
    queryClient.invalidateQueries({ queryKey: [queryKey] });
  }
};
